"use client";

import Footer from "@/components/organisms/footer";
import Header from "@/components/organisms/header";
import { motion } from "motion/react";
import { useEffect, useState } from "react";

// Effects never run on the server, so server HTML always renders the page visible
// (crawlers see it) and only client-side navigations get the fade-in.
let hasHydrated = false;

const Layout = ({
  isEventPage,
  settingAPI,
  footerAPI,
  className = "",
  children,
  style = {},
}) => {
  const [skipFade] = useState(() => !hasHydrated);

  useEffect(() => {
    hasHydrated = true;
  }, []);

  const pageTransition = {
    initial: { opacity: 0 },
    enter: {
      opacity: 1,
      transition: { duration: 0.3, delay: 0.1, ease: "easeOut" },
    },
    exit: {
      opacity: 0,
      pointerEvents: "none",
      transition: { duration: 0.2, ease: "easeIn" },
    },
  };

  return (
    <motion.main
      initial={skipFade ? false : "initial"}
      animate="enter"
      exit="exit"
      variants={pageTransition}
      className={`relative w-full min-h-[100svh] flex flex-col ${className}`}
      style={style}
    >
      <Header settingAPI={settingAPI} isEventPage={isEventPage} />
      {children}
      <Footer footerAPI={footerAPI} />
    </motion.main>
  );
};

export default Layout;
